<template>
  <main-dropdown>
    <template slot-scope="context">
      <img
        @click="context.toggleOpen"
        class="h-10 w-10 cursor-pointer rounded-full border-2 border-gray-400 object-cover"
        :src="userData.avatar"
        alt="profile image"
      />
      <transition
        enter-active-class="transition-all duration-100 ease-out"
        leave-active-class="transition-all duration-100 ease-in"
        enter-class="opacity-0 scale-75"
        enter-to-class="opacity-100 scale-100"
        leave-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-75"
      >
        <div
          v-if="context.open"
          class="origin-top-right absolute right-0 mt-2 w-64 bg-white border overflow-hidden rounded-lg shadow-md"
        >
          <ul>
            <li class="flex items-center p-4">
              <!-- <a
                to="/profile"
                class="rounded-t-lg block px-4 py-3 hover:bg-gray-100"
              > -->
              <span class="mr-2">
                <svg
                  fill="currentColor"
                  stroke="none"
                  viewBox="0 0 24 24"
                  class="w-6 h-6"
                >
                  <path
                    d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
                  />
                </svg>
              </span>
              {{ userData.username }}
            </li>
            <!-- <li class="hover:bg-gray-100">
              <a class="font-semibold block px-4 py-3" to="/profile">Profile</a>
            </li> -->
            <li class="hover:bg-gray-100">
              <router-link
                class="flex items-center p-4 hover:bg-green-500 hover:text-white"
                :to="{ name: 'auth-iologout' }"
              >
                <span class="mr-2">
                  <svg
                    fill="currentColor"
                    stroke="none"
                    viewBox="0 0 24 24"
                    class="w-6 h-6"
                  >
                    <path
                      d="M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19
                    9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14
                    2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9
                    9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"
                    />
                  </svg>
                </span>
                Log out
              </router-link>
            </li>
          </ul>
        </div>
      </transition>
    </template>
  </main-dropdown>
</template>

<script>
import MainDropdown from "./MainDropdown";

export default {
  name: "button-with-dropdown",
  components: { MainDropdown },
  props: {
    user: Object
  },
  computed: {
    userData() {
      return this.$props.user;
    }
  }
  /* data() {
    return {
      defaultAvatar: `${process.env.BASE_URL}/images/default-avatar-300x300.png`,
      username: "John Wick",
      email: "dontkillmydog@johnwick.com"
    };
  } */
};
</script>
